import { useState, createContext, useContext } from "react";
const useDepartmentCntx = createContext();
const setDepartmentCntx = createContext();
export function DepartmentCntx({ children }) {
    const [stDepartment, setStDepartment] = useState(null);
    return (
        <useDepartmentCntx.Provider value={stDepartment}>
            <setDepartmentCntx.Provider value={setStDepartment}>
                {children}
            </setDepartmentCntx.Provider>
        </useDepartmentCntx.Provider>
    )
}
export function UseDepartment() {
    return useContext(useDepartmentCntx);
}
export function SetDepartment() {
    return useContext(setDepartmentCntx);
}